export default [
  ['=', '+', '%', '*', '`', '[', ']', '{', '}', '<', '>'],
  ['@', '&', ':', ';', '_', '-', '#', '(', ')', '/', '\\', '|'],
  ['.', ',', '?', '!', "'", '"', '^', '~', '$'],
];
